// Copyright (c) 2017 Deere & Company

import DateRange, {getDefaultState as getDateRangeDefaultState} from '@deere/cps-it.warranty-model-factory/lib/date-range';
import t from 'tcomb';

const Criteria = t.struct({
    claimCreated: DateRange,
    claimNumber: t.String,
    pin: t.String,
    workOrderOne: t.String
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        claimCreated: getDateRangeDefaultState(),
        claimNumber: '',
        pin: '',
        workOrderOne: ''
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/state/criteria.js